import 'css-chunk:src/components/energy-arrow/energy-arrow-component.module.scss';export default {
  "energy-arrow-container": "energy-arrow-component_energy-arrow-container__nnpLF",
  "energy-arrow": "energy-arrow-component_energy-arrow__Yz2Xi",
  "clickable": "energy-arrow-component_clickable__hk2cg",
  "energy-arrow-image": "energy-arrow-component_energy-arrow-image__AJ0HB",
  "energy-arrow-two-images": "energy-arrow-component_energy-arrow-two-images__3WeAv",
  "modal-one-image": "energy-arrow-component_modal-one-image__gl8RI",
  "modal-two-images": "energy-arrow-component_modal-two-images__Kdl53"
};